export const elementType = {
  plant: 'Plant',
  machine: 'Machine',
  segment: 'Segment',
  area: 'Area',
  line: 'Line',
};

export const taxonomyTag = {
  element: 'Element',
  workEvent: 'WorkEvent',
};

export const PlantType = {
  None: 0,
  PackOs: 1,
  LogicPrint5: 2,
  LogicPrint7: 3,
};

export default {
  elementType,
  taxonomyTag,
};
